import initContactAnimation from './../components/contactAnimation';
import validateForm from './../../../_global/js/components/validateForm';



/*
 * barba views
 */
const Contact = {
  namespace: 'contact',
  beforeEnter: (data) => {
  },
  afterEnter: (data) => {
    console.log('contact after enter');
    initContactAnimation(data.next.container);

    let formsToValidate = document.querySelectorAll('form[data-validate]');
    formsToValidate.forEach(form => validateForm(form, {
    	showErrors: false,
    }));
  }
}

export default Contact;
